import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from '@app/secure/service/Api.service';

@Injectable({
    providedIn: 'root'
})

class DocumentService 
{
    private refreshDocumentList = new Subject<void>();

    refreshDocumentList$ = this.refreshDocumentList.asObservable();

    constructor
    (
        private apiService: ApiService
    )
    {}

    triggerRefreshDocumentList() 
    {
        this.refreshDocumentList.next();
    }

    /**
     * @desc   - download a document blob by file id
     * @access - public
     * @param  - object oneDocument : document object
     * @return - Observable serviceObj : document blob response
     */
    getDocumentContent
    (
        oneDocument
    ) : Observable<Blob>
    {
        let postData;
        let serviceObj;

        postData =
        {
            fileId: oneDocument.id
        };
        serviceObj = this.apiService.customPostArrayBlob<Blob>(
            'document/downloadFile',
            postData
        );

        return serviceObj;
    }
} 

export { DocumentService };